import { createSelector } from "@reduxjs/toolkit"
import { selectLastUpdated as lastInfectionUpdate } from "./countriesData.duck"
import { selectLastUpdated as lastIndexUpdate } from "./indexes.duck"

export const selectGlobalLastUpdated = createSelector(
  [lastInfectionUpdate, lastIndexUpdate],
  (...updates) => updates.sort().reverse()[0],
)
